import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import HistoryPriceTableRow from './HistoryPriceTableRow';
import type { HistoryPriceRow } from './model';

interface HistoryPriceTableBodyProps {
    rows: HistoryPriceRow[];
    loading: boolean;
    isUahMode: boolean;
}

const HistoryPriceTableBody = ({ rows, loading, isUahMode }: HistoryPriceTableBodyProps) => {
    const { t } = useTranslation(['Objects']);

    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={4} className="text-center text-muted py-4">
                    {loading ? '\u00A0' : t('historyPrice.empty')}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row) => (
                <HistoryPriceTableRow key={row.ID} row={row} isUahMode={isUahMode} />
            ))}
        </tbody>
    );
};

export default HistoryPriceTableBody;
